import { render, staticRenderFns } from "./KisSubjectArea.vue?vue&type=template&id=f9c893e2"
import script from "./KisSubjectArea.js?vue&type=script&lang=js&external"
export * from "./KisSubjectArea.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports